import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';

@Component({
  selector: 'app-search-filter-name',
  templateUrl: './search-filter-name.component.html',
  styleUrls: ['./search-filter-name.component.scss']
})
export class SearchFilterNameComponent extends DialogBase implements OnInit {

  title: any;
  name: any;

  ngOnInit(): void {
  }

  save() {
    this.onClose.next(this.name);
    this.bsModalRef.hide();
  }
}
